/* eslint-disable react/destructuring-assignment */

import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import pluralize from 'pluralize';
import { BootstrapModal as Modal } from '../../../components/BootstrapModal/BootstrapModal';
import { PortalCallToAction } from '../PortalCallToAction/PortalCallToAction';
import { MoreQualificationsModal } from './MoreQualificationsModal';
import { defaultStrings } from '../../PortalShared';
import './PortalMoreQualifications.scss';

export class PortalMoreQualifications extends React.Component {
  static displayName = 'PortalMoreQualifications';

  static propTypes = {
    onCtaButtonClicked: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    defaultStrings: ImmutablePropTypes.map,
  };

  static defaultProps = { defaultStrings };

  static contextTypes = {
    strings: ImmutablePropTypes.map,
  };

  state = {
    showModal: false,
  };

  onSubmitModal = (data) => {
    this.props.onSubmit(data);
    setTimeout(() => {
      this.setState({ showModal: false });
    }, 300);
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  openModal = () => {
    if (this.Cta && this.props.onCtaButtonClicked) {
      this.props.onCtaButtonClicked(this.Cta.textContent);
    }
    this.setState({ showModal: true });
  };

  render() {
    const { showModal } = this.state;
    const strings = this.props.defaultStrings.merge(this.context.strings);

    return (
      <portal-more-qualifications>
        <div className="row">
          <div className="columns small-11 small-centered medium-10 medium-centered">
            <PortalCallToAction onClick={this.openModal}>
              <span ref={(c) => (this.Cta = c)}>
                MORE {pluralize(strings.get('qualification'), 2).toUpperCase()}
              </span>
            </PortalCallToAction>
            <Modal
              show={showModal}
              onHide={this.closeModal}
              dialogClassName="more-qualifications-modal"
            >
              <MoreQualificationsModal onSubmit={this.onSubmitModal} />
            </Modal>
          </div>
        </div>
      </portal-more-qualifications>
    );
  }
}
